import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const Button = (props) => {
  return (
    <>
    <Wrapper>
    <Link to={props.go} className='a'>{props.text}<img src={props.icon} alt="" /></Link>
    </Wrapper>
    </>
  )
}

const Wrapper = styled.div`

   .a{
    text-decoration: none;
color:#121629 ;
background-color: #cbebf2;
   padding :6px 12px ;
   font-weight: 500;
   border-radius: 10px;
   display: flex;
   gap: 5px;
   align-items: center;
   img{
    width: 15px;
    height: 15px;
    @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
    width: 40px;
        height: 40px;
   
}
    @media (max-width: 480px) {
      width: 25px;
    height: 25px;
        }
   }

   }
   @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   font-size: 2rem;
   
}
   @media (max-width: 480px) {
      font-size: 1.2rem;
        }
`

export default Button